export default "__VITE_ASSET__0a2778bc__"